import type { BadgeDesignTokens, BadgeTokenSections } from '@primeuix/themes/types/badge';

// Number badges (O16, revised 2026-10-09): radius-full; unread counters (danger)
// use the shared counter tokens — orange surface, wine digit, 2px card-colour
// ring + shadow-medium (cleverly-overrides.scss).
export const root: BadgeTokenSections.Root = {
    borderRadius: '{extend.borderRadius.rounded}',
    padding: '0 8px',
    fontSize: '0.75rem',
    fontWeight: '600',
    minWidth: '1.25rem',
    height: '1.25rem'
};

export const dot: BadgeTokenSections.Dot = {
    size: '0.5rem'
};

export const sm: BadgeTokenSections.Sm = {
    fontSize: '0.625rem',
    minWidth: '1.25rem',
    height: '1.25rem'
};

export const lg: BadgeTokenSections.Lg = {
    fontSize: '0.875rem',
    minWidth: '1.75rem',
    height: '1.75rem'
};

export const xl: BadgeTokenSections.Xl = {
    fontSize: '1rem',
    minWidth: '2rem',
    height: '2rem'
};

export const colorScheme: BadgeTokenSections.ColorScheme = {
    light: {
        // orange is a surface only: text on it is wine (O1)
        primary: {
            background: '{primary.500}',
            color: '{primary.contrastColor}'
        },
        secondary: {
            background: '{sand.950}',
            color: '#FFFFFF'
        },
        success: {
            background: '{extend.statesuccessbg}',
            color: '{extend.statesuccess}'
        },
        info: {
            background: '{extend.stateinfobg}',
            color: '{extend.stateinfo}'
        },
        warn: {
            background: '{extend.surfacecream}',
            color: '{extend.textheading}'
        },
        // every unread counter uses danger → the shared counter tokens (O16 revised)
        danger: {
            background: '{extend.badgebackground}',
            color: '{extend.badgecolor}'
        },
        contrast: {
            background: '{sand.950}',
            color: '#FFFFFF'
        }
    },
    dark: {
        primary: {
            background: '{primary.color}',
            color: '{primary.contrastColor}'
        },
        secondary: {
            background: '{surface.800}',
            color: '{surface.300}'
        },
        success: {
            background: '{green.400}',
            color: '{green.950}'
        },
        info: {
            background: '{sky.400}',
            color: '{sky.950}'
        },
        warn: {
            background: '{yellow.400}',
            color: '{primary.950}'
        },
        danger: {
            background: '{red.400}',
            color: '{red.950}'
        },
        contrast: {
            background: '{surface.0}',
            color: '{surface.950}'
        }
    }
};

export default {
    root,
    dot,
    sm,
    lg,
    xl,
    colorScheme
} satisfies BadgeDesignTokens;
